import * as React from 'react';
import { DetailedHTMLProps } from 'react';
import { useMsgText } from './hooks';


interface Props extends DetailedHTMLProps<React.OptionHTMLAttributes<HTMLOptionElement>, HTMLOptionElement> {
  labelKey: string;
  labelText?: string;
}


/**
 * LocalDropdownOption: a component that renders an option element for a select box, with translated content.
 *
 * PureComponent: true
 * Connected to Redux: true
 */
const LocalDropdownOption: React.FC<Props> = props => {
  const { labelKey, labelText, ...rest } = props;

  const label = useMsgText(labelKey, labelText);

  return (
    /*
     * Support for the `label` attribute on options has landed in Firefox in time for v77, meaning we should
     * be able to drop the nested values in early June 2020
     * See https://bugzilla.mozilla.org/show_bug.cgi?id=40545
     */
    <option {...rest} label={label}>{label}</option>
  );
};


export default LocalDropdownOption;
